<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

defineProps<{
  src?: string
  alt?: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="
      cn(
        'flex justify-center items-center w-10 h-10 rounded-full bg-black text-white font-500 text-xs shrink-0',
        $props.class
      )
    "
  >
    <img
      v-if="src"
      :src="src"
      :alt="alt"
      class="w-full h-full object-cover rounded-full"
    />
    <span v-else>
      {{ alt }}
    </span>
  </div>
</template>
